// extracted by mini-css-extract-plugin
export var categories = "thread-meta-module--categories--d810f";
export var container = "thread-meta-module--container--00031";
export var counter = "thread-meta-module--counter--169ed";
export var created = "thread-meta-module--created--07163";
export var dot = "thread-meta-module--dot--b750c";
export var vertical = "thread-meta-module--vertical--badad";